import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";

import {
  AppBar,
  CssBaseline,
  Drawer,
  Hidden,
  IconButton,
  Toolbar,
  Button,
  CircularProgress,
  Badge,
  makeStyles,
  withStyles,
  Typography,
  Tooltip,
  Grid,
} from "@material-ui/core";
import {
  Menu,
  NightsStayOutlined,
  ExitToAppOutlined,
  UpdateOutlined,
  WbSunnyOutlined,
} from "@material-ui/icons";

import Axios from "axios";
// import Cookies from "js-cookie";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { selectUser, setUser } from "../../features/data/user/userSlice";
import { selectTheme, setTheme } from "../../features/data/theme/themeSlice";

import RecentChanges from "../recentChanges/RecentChanges";
import DrawerList from "../drawerList/DrawerList";

const ColorCircularProgress = withStyles({
  root: { color: "#000000" },
})(CircularProgress);

const drawerWidth = "300px";

const useStyles = makeStyles((theme) => ({
  root: { display: "flex" },
  toolbar: theme.mixins.toolbar,
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  menuButton: {
    color: "#000",
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerPaper: { width: drawerWidth },
  content: { flexGrow: 1, alignItems: "center", justifyContent: "center" },
  // wrapper: { border: "1px solid #00000011", borderRadius: 15 },
  nested: { paddingLeft: theme.spacing(4) },
}));

const PageView = (props) => {
  // const location = useLocation();
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [lastChangesDialogOpen, setLastChangesDialogOpen] = useState(false);

  const dispatch = useDispatch();
  const { user } = useSelector(selectUser, shallowEqual);
  const { theme } = useSelector(selectTheme, shallowEqual);
  // const user = useSelector(selectUser, shallowEqual);

  const [getUserloading, setGetUserLoading] = useState(false);

  const navigate = useNavigate();
  // const [open, setOpen] = React.useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  useEffect(() => {
    if (!localStorage.getItem("login")) navigate("/login");
    else getUserInfo();
  }, []); // eslint-disable-line

  const getUserInfo = () => {
    setGetUserLoading(true);
    var headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: localStorage.getItem("login"),
      "X-Requested-With": "XMLHttpRequest",
    };
    Axios({
      method: "get",
      url: process.env.REACT_APP_API_URL + "/user",
      headers: headers,
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(setUser(res.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          navigate("/login");
          localStorage.removeItem("login");
        }
      })
      .finally(() => {
        setGetUserLoading(false);
      });
  };

  function handleLogoutButtonClick(e) {
    setLogoutLoading(true);
    var headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Accept: "application/json;charset=UTF-8",
      Authorization: localStorage.getItem("login"),
    };
    Axios.get(process.env.REACT_APP_API_URL + "/logout", {
      headers: headers,
    })
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLogoutLoading(false);
        // Cookies.remove("login");
        localStorage.removeItem("login");
        navigate("/login");
      });
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <RecentChanges
        open={lastChangesDialogOpen}
        onClose={() => setLastChangesDialogOpen(false)}
      />
      <AppBar position="fixed" className={classes.appBar} elevation={0}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <Menu />
          </IconButton>

          <div style={{ flexGrow: 1 }} />

          <Typography
            color="primary"
            style={{ marginLeft: 20, fontSize: 15, fontWeight: "300" }}
          >
            {user?.work_title}
          </Typography>

          <Typography
            color="primary"
            style={{ marginLeft: 20, fontSize: 15, fontWeight: "100" }}
          >
            |
          </Typography>

          {/* <IconButton
            onClick={() => dispatch(setTheme(theme === "light" ? "dark" : "light"))}
            size='small'
            style={{ marginLeft: 10 }}
          >
            {theme === "light" ? <WbSunnyOutlined /> : <NightsStayOutlined />}
          </IconButton> */}

          <Tooltip title="تغییرات اخیر">
            <IconButton
              onClick={() => setLastChangesDialogOpen(true)}
              size="small"
              style={{ marginLeft: 10 }}
            >
              <Badge
                color="error"
                variant="dot"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                invisible={
                  new Date().getTime() - new Date("2022-09-06").getTime() >
                  24 * 5 * 60 * 60 * 1000
                }
              >
                <UpdateOutlined />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip title="خروج">
            <IconButton size="small" onClick={handleLogoutButtonClick}>
              {logoutLoading ? (
                <ColorCircularProgress size={24} />
              ) : (
                <ExitToAppOutlined />
              )}
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer}>
        <Hidden smUp implementation="js">
          <Drawer
            // container={container}
            variant="temporary"
            anchor="left"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{ paper: classes.drawerPaper }}
            ModalProps={{ keepMounted: true }}
          >
            <DrawerList onClose={() => setMobileOpen(false)} />
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="js">
          <Drawer
            classes={{ paper: classes.drawerPaper }}
            variant="permanent"
            open
          >
            <DrawerList onClose={() => setMobileOpen(false)} />
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Outlet />
      </main>
    </div>
  );
};

export default PageView;
